// extracted by mini-css-extract-plugin
export default {"heading":"PrivacyPolicyPage_heading__HNcyO","content":"PrivacyPolicyPage_content__GaLrv","privacyTabs":"PrivacyPolicyPage_privacyTabs__m68ah"};